import React, { FC } from 'react'
import { Button } from '../lib/button'
import SvgTune from '../lib/curon-icon/Tune'
import { Flexbox } from '../lib/view'

type Props = {
  onClick: () => void
  mt?: string
}

export const ServiceTagFilterBoxButton: FC<Props> = ({
  onClick,
  mt = '0px',
}) => {
  return (
    <Button
      shape="square"
      colorStyle="green-outlined"
      borderRadius={'4px'}
      fontSize={'12px'}
      height={'32px'}
      width={'100%'}
      mt={mt}
      mb={'8px'}
      onClick={onClick}
    >
      <Flexbox alignItems={'center'} style={{ columnGap: '4px' }}>
        <SvgTune size={'20'} />
        詳細検索
      </Flexbox>
    </Button>
  )
}
